export const maskStyles = {
  border: '1.54px solid transparent',
  background:
    'linear-gradient(to right, rgba(255,255,255,0.4), rgba(255,255,255,0.15), rgba(255,255,255,0)) border-box',
  WebkitMask: 'linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)',
  WebkitMaskComposite: 'xor',
  maskComposite: 'exclude',
}
